export default {
  listRecordSituations: [],
  recordSituation: {
    ativo: true,
    id: 0,
    nome: '',
    padrao: true,
  },
}
